module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"message":"hello i18n !!","messagebtn":"Show message"}')
  delete Component.options._Ctor
}
